import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, LayoutDashboard, Menu, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import InfoPanel from "@/pages/Dashboard/InfoPanel";
import telegramLogo from "@/assets/telegram.svg";
import "@/pages/Dashboard/UserDashboard.css";

const exampleAccount = {
  telegram_id: "@example_user",
  user_nickname: "示例用户",
  membership_expiry: "2026-12-31T23:59:59+08:00",
  balance: 120,
  checkin_enabled: true,
};

export default function OverviewPreviewPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [navigationNotice, setNavigationNotice] = useState("");

  return (
    <div className="user-shell user-preview">
      {sidebarOpen && <button className="user-sidebar-backdrop" aria-label="关闭导航" onClick={() => setSidebarOpen(false)} />}
      <aside className={`user-sidebar ${sidebarOpen ? "is-open" : ""}`}>
        <div className="user-brand"><span className="user-brand-mark"><img src={telegramLogo} alt="" /></span><span><strong>TG Checkin</strong></span></div>
        <nav className="user-nav" aria-label="预览导航"><div className="user-nav-item is-active" aria-current="page"><LayoutDashboard size={18} /><span>账户概览</span><span className="user-nav-indicator" /></div></nav>
        <div className="user-sidebar-bottom"><Link to="/dashboard" className="user-sidebar-link"><ArrowLeft size={17} /> 返回个人中心</Link></div>
      </aside>
      <div className="user-workspace">
        <header className="user-topbar">
          <button className="user-menu-button" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label={sidebarOpen ? "关闭导航" : "打开导航"}>{sidebarOpen ? <X size={21} /> : <Menu size={21} />}</button>
          <div className="user-breadcrumb"><span>界面预览</span><span className="user-breadcrumb-divider">/</span><strong>账户概览</strong></div>
          <div className="user-topbar-actions"><span className="user-connection is-connected"><i />Telegram 模拟已连接</span><ThemeToggle /><span className="user-avatar">示</span></div>
        </header>
        <main className="user-main">
          <div className="user-page-heading"><h1>账户概览</h1></div>
          <div className="user-preview-notice" role="note"><strong>界面预览</strong><span>这里使用示例账户展示布局。开关和密码窗口可以体验，但不会保存配置、修改密码或执行打卡。</span></div>
          {navigationNotice && <p className="user-inline-notice" role="status">{navigationNotice}</p>}
          <InfoPanel data={exampleAccount} refresh={() => {}} onNavigate={() => setNavigationNotice("这是账户概览预览，其他功能请登录后使用。") } sessionConnected selectedCount={2} preview />
        </main>
      </div>
    </div>
  );
}
